import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { AccessibleDragAndDropComponent } from './accessible-drag-and-drop.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule
    ],
    declarations: [
        AccessibleDragAndDropComponent
    ],
    exports: [
        AccessibleDragAndDropComponent
    ],
    providers: []
})
export class AccessibleDragAndDropModule {}
